export const OWNERSHIP_TYPES = [
  { value: "electronic_deed", labelAr: "صك إلكتروني", labelEn: "Electronic Deed" },
  { value: "real_estate_record", labelAr: "سجل عقاري", labelEn: "Real Estate Record" },
  { value: "paper_deed", labelAr: "صك ورقي", labelEn: "Paper Deed" },
  { value: "deed_dispute", labelAr: "صك محل نزاع", labelEn: "Deed Dispute" },
  { value: "deed_heirs", labelAr: "صك مع حصر ورثة", labelEn: "Deed with a list of heirs" },
  { value: "electronic_ejar", labelAr: "عقد إيجار إلكتروني", labelEn: "Electronic Ejar contract" },
  { value: "ejar_status", labelAr: "حالة إيجار إلكتروني", labelEn: "Electronic Ejar Status" },
  { value: "mortgage_deed", labelAr: "صك رهن", labelEn: "Mortgage Deed" },
  { value: "deed_sales", labelAr: "صك مع عقد بيع", labelEn: "Deed with sales contract" },
  { value: "deed_endowment", labelAr: "صك مع شهادة وقف", labelEn: "Deed with endowment certificate" },
  { value: "deed_esnad", labelAr: "صك مع إسناد", labelEn: "Deed with Esnad" },
  { value: "beneficial_ownership", labelAr: "وثيقة ملكية منفعة", labelEn: "Beneficial ownership document" },
  { value: "deed_guardianship", labelAr: "صك مع ولاية", labelEn: "Deed with guardianship" },
  { value: "deed_judicial", labelAr: "صك مع أمر قضائي", labelEn: "Deed with a judicial order" },
  { value: "wafi_contract", labelAr: "عقد وافي", labelEn: "WAFI Contract" },
  { value: "deed_ministerial", labelAr: "صك مع قرار وزاري", labelEn: "Deed with a ministerial decision" },
] as const;

export type OwnershipTypeValue = (typeof OWNERSHIP_TYPES)[number]["value"];
